import type { OwaDate, GlobalCalendarLocale } from "owa-datetime";
import { localizedFormatter } from "./localizedFormatter";

/**
 * User time format with the AM/PM period removed, e.g. "4:35" instead of "4:35 PM". Preserves any
 * quoted literal text in the format and leaves 24-hour formats (which carry no period) unchanged.
 * Useful for a same-period time range where the trailing period only needs to appear once, e.g.
 * "4:35 - 5:00 PM".
 */
export function getUserTimeWithoutPeriodFormat(_dateFormat: string, timeFormat: string): string {
    return timeFormat
        .replace(/'[^']*'|t{1,2}/g, match => (match.charAt(0) === "'" ? match : ""))
        .replace(/\s{2,}/g, " ")
        .trim();
}

let format: ReturnType<typeof localizedFormatter> | undefined;

export default function formatUserTimeWithoutPeriod(date: OwaDate | null | undefined, locale?: GlobalCalendarLocale): string {
    format ??= localizedFormatter(getUserTimeWithoutPeriodFormat);
    return format(date, locale);
}
